export var activatableButtonIcon = 'activatable-button-icon';
export var buttonFocused = 'button-is-focused';
export var buttonLoading = 'is-loading';